//currently this component will only works for android.
import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ReactNode, useMemo } from 'react';
import CtaComponent from '../reusable-ui/cta';
import {
  compareVersions,
  triggerAppEvent,
  webviewParentDevice,
} from '../../helpers/common-helper';
import {
  CTA_SIZE,
  CTA_TYPE,
  digitalShowroomAndroidAppLink,
} from '../../data/constants';
import { getAppVersion } from '../../features/credit-report-apply/helper';

type Props = {
  children?: ReactNode;
  supportedVersion: string;
};

function UnsupportedInfo({ children, supportedVersion }: Props) {
  const version = getAppVersion();
  const device = webviewParentDevice();

  const isNotAllowed = useMemo(() => {
    if (version && device === 'android') {
      return compareVersions(version, supportedVersion) < 0;
    } else {
      return false;
    }
  }, [version, device]);

  if (isNotAllowed) {
    return (
      <Stack
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        spacing={2}
        px={3}
        width={'100vw'}
        height={'100vh'}>
        <Typography textAlign={'center'} color={'grey.400'}>
          This feature is supported on version {supportedVersion} or above this.
          Please update your app.
        </Typography>
        <CtaComponent
          ctaText="Update App"
          ctaSize={CTA_SIZE.small}
          ctaType={CTA_TYPE.primary_cta}
          onCtaClick={() =>
            triggerAppEvent({
              redirectBrowser: true,
              redirectURL: digitalShowroomAndroidAppLink,
              data: digitalShowroomAndroidAppLink,
            })
          }></CtaComponent>
      </Stack>
    );
  }
  return <>{children}</>;
}

export default UnsupportedInfo;
